import React from 'react';
import Logo from '../../../images/logo-simple-white.svg';
import styles from './OslaLoader.module.scss';

export const OslaLoader = () =>
  <div className={styles.preloader}>
    <img src={Logo} alt="" />
  </div>;